import { A } from '@solidjs/router';
import { createSignal, Show } from 'solid-js';
import {
  AND,
  BY_SIGNING_IN_I_AGREE_TO_THE,
  EMAIL,
  GET_MAGIC_LINK,
  PRIVACY_POLICY,
  SIGN_IN_WITH_EMAIL_AND_PASSWORD,
  SIGN_IN_WITH_PHONE_NUMBER,
  TERMS_OF_SERVICE,
} from '~/assets/strings';
import { Checkbox } from '~/components/common/Inputs/Checkbox';
import ActivityIndicator from '~/components/common/activity-indicator/ActivityIndicator';
import { useLocalization } from '~/hooks/useLocalization';
import { LoginType } from '~/types/LoginType';

interface MagicLinkSignInProps {
  onLoginTypeChange: (type: LoginType) => void;
  onSubmit: (email: string) => void;
  isLoading: boolean;
  message?: string;
}

export const MagicLinkSignIn = (props: MagicLinkSignInProps) => {
  const { t } = useLocalization();
  const [agreeTerms, setAgreeTerms] = createSignal<boolean>(true);

  return (
    <>
      <div class="flex flex-col gap-2">
        <label class="text-gray-600" for="email">
          {t(EMAIL)}
        </label>
        <input
          type="email"
          id="email"
          name="email"
          autocomplete="username"
          class="w-full rounded-md border border-gray-300 px-4 py-3"
          placeholder="magicdoor@gmail.com"
          required
        />
      </div>

      <div class="flex items-start gap-2">
        <Checkbox
          checkBoxClass="mt-1"
          name="terms-of-service"
          checked={agreeTerms()}
          required
          onClick={() => setAgreeTerms((prev) => !prev)}
        />
        <div class="text-sm text-gray-600">
          <p>
            {t(BY_SIGNING_IN_I_AGREE_TO_THE)}{' '}
            <A class="text-blue-600 hover:underline" href="/tenants/terms-of-service" target="_blank">
              {t(TERMS_OF_SERVICE)}
            </A>{' '}
            {t(AND)}{' '}
            <A class="text-blue-600 hover:underline" href="/tenants/privacy-policy" target="_blank">
              {t(PRIVACY_POLICY)}
            </A>
          </p>
          <p class="mt-2">{t('By signing in, you consent to receive text messages from MagicDoor. Message and data rates may apply.')}</p>
        </div>
      </div>

      <Show when={props.isLoading}>
        <div class="flex justify-center">
          <ActivityIndicator size={30} />
        </div>
      </Show>

      <Show when={props.message}>
        <div class="text-green-500">{props.message}</div>
      </Show>

      <button
        type="submit"
        disabled={props.isLoading || !agreeTerms()}
        class="h-16 w-full rounded-md bg-blue-600 font-medium text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-gray-300">
        {t(GET_MAGIC_LINK)}
      </button>

      <div class="flex flex-col items-end gap-2">
        <a onClick={() => props.onLoginTypeChange(LoginType.Account)} class="cursor-pointer text-blue-500 underline hover:text-blue-800">
          {t(SIGN_IN_WITH_EMAIL_AND_PASSWORD)}
        </a>
        <a
          onClick={() => props.onLoginTypeChange(LoginType.PhoneNumber)}
          class="cursor-pointer text-blue-500 underline hover:text-blue-800">
          {t(SIGN_IN_WITH_PHONE_NUMBER)}
        </a>
      </div>
    </>
  );
};
